export default __webpack_public_path__ + "static/media/gallery_15.ecc2c1a2.jpg";